<template>
  <div id="app" class="container-fluid">
    <notifications group="alert" class="notify" />
    <router-view></router-view>
  </div>
</template>

<script>
  import 'bootstrap/dist/css/bootstrap.css'
  import 'bootstrap/dist/js/bootstrap.js'
  import 'font-awesome/css/font-awesome.min.css'

  export default {
    name: 'device_config_tool'
  }
</script>

<style>
  #app {
    overflow-x: hidden;
  }

	.notify .success {
		background: #68CD86;
	}
	.notify .warning {
		background: #ffb648;
	}
	.notify .error {
		background: #E54D42;
	}

	.notify .success {
		border-left-color: #38AA5A;
	}
	.notify .warning {
		border-left-color: #f90;
	}
	.notify .error {
		border-left-color: #AD0C00;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue